import * as yup from "yup";
import { isOibValid } from "ui/components/TextField/OibTextField/validation";
import { isEmailValid } from "ui/components/TextField/EmailTextField/emailUtils";
import { isWebUrlValid } from "ui/components/TextField/WebTextField/webUtils";

export const TENANT_INFO_FORM_SCHEMA = yup.object().shape({
  tenantTypeId: yup
    .string()
    .nullable()
    .required("Molimo Vas da odaberete tip tenanta"),
  companyName: yup
    .string()
    .nullable()
    .when("tenantTypeId", {
      is: (val: string) => val === "C",
      then: (schema) => schema.required("Molimo Vas da unesete naziv tvrtke"),
      otherwise: (schema) => schema.notRequired(),
    }),
  firstName: yup
    .string()
    .nullable()
    .when("tenantTypeId", {
      is: (val: string) => val === "P",
      then: (schema) => schema.required("Molimo Vas da unesete ime"),
      otherwise: (schema) => schema.notRequired(),
    }),
  lastName: yup
    .string()
    .nullable()
    .when("tenantTypeId", {
      is: (val: string) => val === "P",
      then: (schema) => schema.required("Molimo Vas da unesete prezime"),
      otherwise: (schema) => schema.notRequired(),
    }),
  headquartersAddress: yup
    .string()
    .nullable()
    .when("tenantTypeId", {
      is: (val: string) => val === "C",
      then: (schema) => schema.required("Molimo Vas da unesete adresu sjedišta"),
      otherwise: (schema) => schema.notRequired(),
    }),
  phoneNumber: yup.string().nullable(),
  /*
    Obavezan je barem jedan broj, ne oba. Provjera stoji na mobitelu jer je on prvo
    polje u redu, pa poruka pada uz njega; da stoji na oba, ista bi se greška
    ispisala dvaput.
  */
  mobilePhoneNumber: yup
    .string()
    .nullable()
    .test(
      "barem-jedan-broj",
      "Unesite barem jedan broj, mobitel ili telefon",
      function (value) {
        return !!value || !!this.parent.phoneNumber;
      }
    ),
  email: yup
    .string()
    .nullable()
    .test("valid-email", "Neispravna email adresa", (value) => {
      if (!value) return true;
      return isEmailValid(value);
    }),
  web: yup
    .string()
    .nullable()
    .test("valid-web", "Neispravna web adresa", (value) => {
      if (!value) return true;
      return isWebUrlValid(value);
    }),
  personalIdentificationNumber: yup
    .string()
    .nullable()
    .when("tenantTypeId", {
      is: (val: string) => val === "C",
      then: (schema) => schema.required("Molimo Vas da unesete OIB"),
      otherwise: (schema) => schema.notRequired(),
    })
    .test("valid-oib", "Neispravan OIB", (value) => {
      if (!value) return true;
      return isOibValid(value);
    }),
  timezone: yup
    .string()
    .nullable()
    .required("Molimo Vas da unesete vremensku zonu"),
});
